
import { useState, useCallback } from "react";

interface UseMenuStateProps {
  setIsToolbarVisible?: (visible: boolean) => void;
}

export const useMenuState = ({ setIsToolbarVisible }: UseMenuStateProps) => {
  const [showHistory, setShowHistory] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const updatePointerEvents = useCallback((enable: boolean) => {
    if (enable) {
      setTimeout(() => {
        document.body.style.pointerEvents = 'auto';
      }, 300);
    } else {
      document.body.style.pointerEvents = 'none';
    }
  }, []);

  const setMenuItemOpen = useCallback((setStateFunc: (state: boolean) => void) => {
    setStateFunc(true);
    setIsToolbarVisible?.(false);
    updatePointerEvents(false);
  }, [setIsToolbarVisible, updatePointerEvents]);

  const setMenuItemClosed = useCallback((setStateFunc: (state: boolean) => void) => {
    setStateFunc(false);
    setIsToolbarVisible?.(true);
    updatePointerEvents(true);
  }, [setIsToolbarVisible, updatePointerEvents]);

  return {
    showHistory,
    showProfile,
    showFeedback,
    handleMenuItemOpen: useCallback((type: 'history' | 'profile' | 'feedback') => {
      switch (type) {
        case 'history':
          setMenuItemOpen(setShowHistory);
          break;
        case 'profile':
          setMenuItemOpen(setShowProfile);
          break;
        case 'feedback':
          setMenuItemOpen(setShowFeedback);
          break;
      }
    }, [setMenuItemOpen]),
    handleMenuItemClose: useCallback((type: 'history' | 'profile' | 'feedback') => {
      switch (type) {
        case 'history':
          setMenuItemClosed(setShowHistory);
          break;
        case 'profile':
          setMenuItemClosed(setShowProfile);
          break;
        case 'feedback':
          setMenuItemClosed(setShowFeedback);
          break;
      }
    }, [setMenuItemClosed]),
  };
};
